// Longterm / Lovespreadsheets API (used for testing e.g. Account Analytics)
// Same pattern as API_Root.js so you can add localhost vs production logic later if needed.

const browserDomain = window.location.origin;

let API_Longterm_Root;

if (browserDomain.includes("localhost")) {
    API_Longterm_Root = "http://127.0.0.1:8000/";
    // API_Longterm_Root = "https://api.lovespreadsheets.com/";
} else {
    API_Longterm_Root = "https://api.lovespreadsheets.com/";
}

export default API_Longterm_Root;
